module.exports = __webpack_public_path__ + "static/img/level-prefix.f3e2dcfa.svg";